export const environment = {
  version: '1.39b',
  production: true,
  apiUrl: '/api/',
  modeDebug: true,
  domain: 'localhost'
};
